export function getActiveSalesPrice(variant) {
    if (variant.aktionsPreis) {
        return variant.aktionsPreis;
    } else {
        return variant.vk_preis ?? 0;
    }
}

const VALID_GTIN_LENGTHS = [8, 12, 13, 14];

export function gtinToJsonLd({ gtin }) {
    if (!gtin) return;
    const { length } = gtin;
    if (!VALID_GTIN_LENGTHS.includes(length)) return;
    return {
        [`gtin${length}`]: gtin,
    };
}
